import { ListValueModel } from './list-value.model';
import { BaseModel } from './base.model';

export class AttachmentModel extends BaseModel {

    name: string;
    file_type: string;
    generated_name: string;

    checklist_id: number;
    signature_user_id: number;

    removed: boolean;
    resized: boolean;
    compressed: boolean;
    occurred_exception: boolean;

    // ??
    belongs_to_unconformity: boolean;
    
    file: File;
    
    parent: string;
    parentId: string;

    list_id: number;
    list: ListValueModel;

    constructor(attachment?: AttachmentModel) {
        super();

        this.file = attachment ? attachment.file || null : null;

        this.name = attachment ? attachment.name || null : null;
        this.file_type = attachment ? attachment.file_type || null : null;
        this.checklist_id = attachment ? attachment.checklist_id || null : null;
        this.generated_name = attachment ? attachment.generated_name || null : null;

        this.removed = attachment ? attachment.removed || null : null;
        this.resized = attachment ? attachment.resized || null : null;
        this.compressed = attachment ? attachment.compressed || null : null;
        this.occurred_exception = attachment ? attachment.occurred_exception || null : null;

        this.parent = attachment ? attachment.parent || null : null;
        this.parentId = attachment ? attachment.parentId || null : null;

        this.list = attachment ? attachment.list || null : null;
        this.list_id = attachment ? attachment.list_id || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/attachment.model.ts